import React, { useState, useEffect } from "react";
import QuoteDetailedPackage from "./QuoteDetailedPackage";

// import firebase from "../../../app/config/firebase";
// const firestore = firebase.firestore();

export default function QuoteDetailedPackages({ quote, quotePackages, profile, onReorderPackages }) {
    const handleMovePackage = (fromIndex, toIndex) => {
        if (!quotePackages || quotePackages.length === 0) return;
        if (toIndex < 0 || toIndex >= quotePackages.length) return;
        const next = [...quotePackages];
        const [moved] = next.splice(fromIndex, 1);
        next.splice(toIndex, 0, moved);
        if (onReorderPackages) {
            onReorderPackages(next);
        }
    };

    return (
        <>
            {quotePackages &&
                quote &&
                quote.id &&
                quotePackages.length > 0 &&
                quotePackages.map((quotePackage, index) => (
                    <QuoteDetailedPackage
                        key={quotePackage.id}
                        quote={quote}
                        quotePackage={quotePackage}
                        profile={profile}
                        quotePackages={quotePackages}
                        packageIndex={index}
                        packageCount={quotePackages.length}
                        onMovePackage={handleMovePackage}
                    />
                ))}
        </>
    );
}
